<template>
  <customModal :containersm="true" @closeModal="closeModal">

    <template #title>
      {{ isEditMode ? 'Update SDV Plan' : 'Create SDV Plan' }}
    </template>

    <template #body>
      <div class="row">

        <!-- Plan Name -->
        <div class="col-md-6 form-group mb-2">
          <label class="mb-0">
            Plan Name <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input v-model="plan.planName" @input="clearError('planName')" class="form-control" type="text"
            maxlength="100" />
          <span v-if="errors.planName" class="errormsg ml-0">
            {{ errorMessages.planName }}
          </span>
        </div>

        <!-- Effective From -->
        <div class="col-md-6 form-group mb-2">
          <label class="mb-0">
            Effective From <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input v-model="plan.effectiveFrom" @input="clearError('effectiveFrom')" class="form-control" type="date"
            :min="minEffectiveDate" />
          <span v-if="errors.effectiveFrom" class="errormsg ml-0">
            {{ errorMessages.effectiveFrom }}
          </span>
        </div>

        <div class="col-md-6 form-group mb-2">
          <label class="mb-0">
            Study Version <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <select v-model="plan.studyVersion" @change="clearError('studyVersion')" class="form-select"
            :disabled="isEditMode">
            <option value="" disabled>Select study version</option>
            <option v-for="sv in studyVersionList" :key="sv.version" :value="sv.version">
              {{ sv.version }}
            </option>
          </select>
          <span v-if="errors.studyVersion" class="errormsg ml-0">
            {{ errorMessages.studyVersion }}
          </span>
        </div>

      </div>

      <!-- Description -->
      <div class="form-group mb-2">
        <label class="mb-0">Description</label>
        <textarea v-model="plan.description" class="form-control" rows="2"></textarea>
      </div>

      <!-- Change Reason (shown + required only when an active plan exists for this study) -->
      <div class="form-group mb-2" v-if="hasActivePlan">
        <label class="mb-0">
          Change Reason <sup><i class="fa fa-asterisk required"></i></sup>
        </label>
        <textarea v-model="plan.changeReason" @input="clearError('changeReason')" class="form-control"
          rows="2"></textarea>
        <span v-if="errors.changeReason" class="errormsg ml-0">
          {{ errorMessages.changeReason }}
        </span>
      </div>

      <div class="text-right">
        <button class="save_btn py-1 px-3" @click="submitPlan" :disabled="loading">
          {{ isEditMode ? 'Update' : 'Save' }}
        </button>
      </div>

    </template>
  </customModal>
</template>
<script src="./SdvPlanModal.js"></script>